import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService } from '../../shared';
import { Core2Config } from '../../shared';
import { EntityPurchaseCreditTermsImportFileContainerModel } from '../../../../../../models/aggregates/erp/credit/index';

@Injectable({
  providedIn: 'root'
})
export class EntityPurchaseCreditTermsImportFileService extends BaseApiTemplateService<EntityPurchaseCreditTermsImportFileContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'entity-purchase-credit-term-import-file-hdrs/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'entity-purchase-credit-term-import-file-hdrs/backoffice-ep';
    this.httpClient = http;
  }

  public downloadSampleCSV(apiVisa: ApiVisa) {
    const CSV_URL = apiVisa.api_domain_url + this.endpoint_path + '/download-master-data-template';
    return this.httpClient.get(CSV_URL, this.getHttpHeaderBlob(apiVisa));
  }
}